import colors from './colors';
import media, { breakpointNames, defaultBreakpoints as breakpoints, generateBreakpointsList, generateMedia, } from './media';
import spacing from './spacing';
import typeStyles from './typeStyles';
const theme = {
    borderRadiusDefault: 0,
    breakpointNames,
    breakpoints,
    breakpointsList: generateBreakpointsList(breakpoints),
    colors,
    durationDefault: '250ms',
    easingDefault: 'ease-in-out',
    generateMedia,
    media,
    spacing,
    typeStyles,
};
export default theme;
